import React from 'react';
import sisterPhoto from '../assets/SisterPicture.jpg';

const About = () => {
  return (
    <div className="bg-white py-16">
      <div className="container m-auto px-6 text-gray-600 md:px-12 xl:px-6">
        <div className="space-y-6 md:flex md:gap-6 md:space-y-0 lg:items-center lg:gap-12">
          <div className="md:5/12 lg:w-5/12">
            <img
              src={sisterPhoto}
              className="h-[600px]"
              alt="image"
              loading="lazy"
            />
          </div>
          <div className="md:7/12 lg:w-6/12">
            <h2 className="text-2xl font-bold text-gray-900 md:text-4xl">
              Helping you find the right person for your needs.
            </h2>

            <p className="mt-4 font-medium text-xl text-gray-600">
              Jobs For Us staffing agency was started to help newly incoming
              immigrants from Latin America and the Caribbean find employment
              opportunities, we understand that finding reliable and skilled
              workers can be a challenge, especially in today's tight labor
              market. That's why we have a deep pool of talented immigrant
              workers who are eager to contribute their skills and work ethic to
              your business.Our workers are hardworking and dedicated
              individuals who have come to America for a better life. They bring
              a diverse set of skills and experiences, and are eager to work in
              a variety of industries, from manufacturing to healthcare,
              construction, and more. Whether you need workers for low-skilled
              or high-skilled positions, we have the perfect candidate for you.
              Our recruitment process is thorough and efficient, we ensure that
              all our workers are authorized to work in the USA, and that they
              are fully vetted and screened, to ensure that they meet the
              highest standards of reliability, productivity, and safety. We
              also recognize that the integration of immigrants into a new
              community can be challenging. That's why we provide our workers
              with additional support and resources, such as language classes,
              cultural orientation, and transportation assistance, to help them
              thrive in their new environment. Jobs For Us is your go-to
              solution for finding and retaining highly skilled and motivated
              immigrant workers who will drive the growth of your business.
              Contact us today to schedule a consultation and learn how we can
              help you meet your labor needs.
            </p>
            <div className="bg-blue rounded-sm"> </div>
            <h4 className=" py-5 text-1l font-bold text-gray-900 md:text-1l">
              Chairwoman - Erlendre Lamy
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
